import type { ReactElement, ReactNode } from 'react';
import { Accordion, BasicCollapsible, Column, GridContainer, Row } from '@vp/swan';

export type FAQ = {
    question: ReactElement | string;
    answer: ReactNode;
    id?: string;
};

export type FAQSchema = {
    question: string;
    answer: string;
};

interface FAQAccordionProps {
    faqData: FAQ[];
    faqSchemaData: FAQSchema[];
}

const FAQAccordion = ({ faqData, faqSchemaData }: FAQAccordionProps) => {
    const generateFAQSchema = (faqSchemaData: FAQSchema[]) => {
        return {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqSchemaData.map((faq) => {
                return {
                    '@type': 'Question',
                    name: faq.question,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: faq.answer,
                    },
                };
            }),
        };
    };

    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(generateFAQSchema(faqSchemaData)),
                }}
            />
            <Accordion>
                {faqData.map(({ question, answer, id }, index) => (
                    <BasicCollapsible
                        key={`faq-${id || index}`}
                        collapsibleId={`faq-${id || index}`}
                        heading={question}
                        headingLevel="h3"
                    >
                        <GridContainer>
                            <Row>
                                <Column span={9} spanXs={12} spanSm={12}>
                                    {answer}
                                </Column>
                            </Row>
                        </GridContainer>
                    </BasicCollapsible>
                ))}
            </Accordion>
        </>
    );
};

export default FAQAccordion;
